import { dictionary } from "./i18n/dictionary";

export const languageLabels: Record<string, string> = {
  NL: dictionary.dutch,
  EN: dictionary.english,
};
